// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"2c315b80","120":"d7723744","248":"0bffdc26","329":"f77680be","470":"8fa18346","493":"1b419ca6","536":"c3c0ae22","606":"6839b07f","809":"7690796d","838":"9e285ff2","856":"a8d77f1f","904":"7f4a7764"}[chunkId] + ".chunk.js";
};